<div class="row shadow p-4 mb-5 bg-white rounded mt-3 monitor-dashboard-chart-card">
    <div class="col-12">
        <div class="d-flex align-items-center mb-2">
            <h5 class="mb-0 monitor-dashboard-card-title">
                <span class="monitor-dashboard-chart-title-link" @click="onTitleClick">{{$t('monitorDashboard.delayedRequests')}}:</span>
                <span class="monitor-dashboard-chart-total">{{ totalCount }}</span>
            </h5>
        </div>

        <div class="monitor-dashboard-chart-stage">
            <div v-show="!isLoading && hasData" class="monitor-dashboard-delayed-scroll"
                :style="{ overflowY: 'auto', overflowX: 'auto' }"
                role="region"
                :aria-label="$t('monitorDashboard.delayedRequests')">
                <div class="monitor-dashboard-delayed-inner" :style="{
            height: chartHeight + 'px',
            minHeight: scrollHeight + 'px',
            minWidth: delayedInnerMinWidth + 'px',
            opacity: hasData ? 1 : 0.35
          }">
                    <canvas :id="canvasId" :height="chartHeight" class="monitor-dashboard-chart-canvas" role="img"
                        :aria-label="$t('monitorDashboard.delayedRequests')"></canvas>
                </div>
            </div>

            <div v-if="isLoading" class="monitor-dashboard-skeleton-wrap" role="status" aria-live="polite">
                <span class="sr-only">{{$t('monitorDashboard.loading')}}</span>
                <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-block" aria-hidden="true"></div>
                <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line" aria-hidden="true"></div>
            </div>

            <div v-else-if="!hasData"
                class="monitor-dashboard-state-block">
                <p class="mb-0 font-weight-bold">{{ $t('monitorDashboard.noRequestsDataFor', { chartName: $t('monitorDashboard.delayedRequests') }) }}</p>
            </div>
        </div>
    </div>
</div>
